import loadable from '@loadable/component';
import Loading from '../components/Loader';

const BunningsGetQuote = loadable(
  () => import(/* webpackChunkName: "BunningsGetQuote" */ '../containers/BunningsGetQuotes'),
  { fallback: Loading }
);

export default BunningsGetQuote;
